import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleApplySecondYearFee } from '../../redux/modules/registration';
import secondYearFeeTotal from '../../selectors/secondYearFeeTotal.selector';

class SecondYearFee extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.toggleApplySecondYearFee();
  }

  getFee() {
    const { applySecondYearFee, secondYearFee } = this.props;
    if (!applySecondYearFee) {
      return '0.00';
    }
    if (Array.isArray(secondYearFee)) {
      return secondYearFee[0];
    }
    return secondYearFee;
  }

  render() {
    const { applySecondYearFee, secondYearFee } = this.props;
    return (
      <div className="Row Registration-secondYearFee">
        <input tabIndex="-1" className="Row-total" data-id="secondYearFeeTotal" id="Rsub1c" data-tooltip="Commercial Vessel Fees (Total State &amp; County)" type="text" value={this.getFee()} readOnly />

        <input className="no-print" type="checkbox" data-id="applySecondYearFee" id="_2ndyear" data-tooltip="Add 2nd year renewal fee" checked={applySecondYearFee && Number(secondYearFee) > 0} onChange={this.handleClick} />
        <label className="no-print" htmlFor="_2ndyear">Add Second Year?</label>
        <b className="print-label print-only">Second Year Fee</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    secondYearFee: secondYearFeeTotal(state),
    applySecondYearFee: state.registration.applySecondYearFee
  };
};

export default connect(mapStateToProps, { toggleApplySecondYearFee })(SecondYearFee);



// WEBPACK FOOTER //
// ./src/containers/registration/SecondYearFee.js